import React from 'react'
import DashboardWelcome from "../components/Organisms/Sections/DashboardWelcome";
import DashboardSuscription from "../components/Organisms/Sections/DashboardSuscription";
import DashboardProgress from "../components/Organisms/Sections/DashboardProgress";
import DashboardLastProcess from "../components/Organisms/Sections/DashboardLastProcess";

const Dashboard = () => {

  return (
    <main className="ed-grid m-grid-6 l-section">
      <div className="ed-grid m-cols-6 lg-cols-4 m-grid-2 lg-x-2 rows-gap">
        <DashboardWelcome />
        <DashboardProgress />
        <DashboardSuscription />
        <DashboardLastProcess />
      </div>
    </main>
  )
}

export default Dashboard
